let loadPromise;

/**
 * Load Cloudflare Turnstile's api.js on-demand (once per page) and resolve
 * ONLY after `window.turnstile` is fully initialised.
 *
 * The script's `onload` fires before Turnstile's own bootstrap completes,
 * so we chain through `turnstile.ready(callback)` — the officially-supported
 * signal that the API is ready to accept `.render()` calls.
 * https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/
 */
export function loadTurnstile() {
  if (typeof window === "undefined") return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const waitReady = () => {
      if (window.turnstile && typeof window.turnstile.render === "function") {
        try { window.turnstile.ready(() => resolve()); }
        catch { resolve(); /* older versions: ready may not accept callback */ }
      } else {
        // The script tag emitted `load` but window.turnstile is still hydrating.
        setTimeout(waitReady, 50);
      }
    };

    const existing = document.querySelector('script[data-cecit-turnstile="1"]');
    if (existing) {
      if (window.turnstile) return waitReady();
      existing.addEventListener("load", waitReady, { once: true });
      existing.addEventListener("error", reject, { once: true });
      return;
    }
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.defer = true;
    s.dataset.cecitTurnstile = "1";
    s.onload = waitReady;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return loadPromise;
}
